import constants from '../constants/appConstants';
import axios from 'axios';
import { getToken } from '../utils/auth';

export const generateDoc = async (id, type) => {
  // Mapeia o tipo para a rota correta
  let endpoint;
  switch (type) {
    case 'new-cautelar':
      endpoint = `${constants.baseURLs.root}/vehicle-report/generate-new-cautelar-report/${id}/dealer`;
      break;
    case 'cautelar':
      endpoint = `${constants.baseURLs.root}/vehicle-report/generate-cautelar-report/${id}/dealer`;
      break;
    case 'laudo-total':
      endpoint = `${constants.baseURLs.root}/vehicle-report/generate-laudo-total/${id}/dealer`;
      break;
    default:
      throw new Error(`Tipo de documento não suportado: ${type}`);
  }

  let config = {
    method: 'get',
    url: endpoint,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + getToken().access_token,
    },
  };

  const response = await axios.request(config);
  return response.status;
};

export const generateWarrantyService = async (id, warrantyData) => {
  const endpoint = `${constants.baseURLs.root}/vehicle-report/generate-warranty-service/${id}/dealer`;

  let config = {
    method: 'post',
    url: endpoint,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + getToken().access_token,
    },
    data: warrantyData,
  };

  const response = await axios.request(config);
  return response.status;
};

export const generateDocStatus = async id => {
  let config = {
    method: 'get',
    url: `${constants.API.getVehicleReportStatus}/${id}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await axios.request(config);
  return response.data;
};
